<template>
  <!-- About Start -->
  <section id="about" class="about">
    <div class="about-decor">
    </div>
    <div class="container">
      <div class="row">
        <div class="column col-md-12">
          <div class="about-contain">
            <div
              style="width: 100%; height: 100%; z-index: 1"
            >
              <div
                class="steps-container static"
                v-bind:class="{
                  active1: stepsActive.first,
                  active2: stepsActive.second,
                  active3: stepsActive.third,
                  active4: stepsActive.forth,
                  active5: stepsActive.fifth,
                }"
              ></div>
              <div
                class="steps-container"
                v-bind:class="{ active: stepsActive.first }"
                @click="onStepClicked('first')"
              >
                <h2 class="title"><slot name="upload"></slot><span></span></h2>
                <h4 class="caption-about">
                  <slot name="upload_description"></slot>
                </h4>
              </div>
              <div
                class="steps-container"
                v-bind:class="{ active: stepsActive.second }"
                @click="onStepClicked('second')"
              >
                <h2 class="title">
                  <slot name="edit_translate"></slot> <span></span>
                </h2>
                <h4 class="caption-about">
                  <slot name="edit_translate_description"></slot>
                </h4>
              </div>
              <div
                class="steps-container"
                v-bind:class="{ active: stepsActive.third }"
                @click="onStepClicked('third')"
              >
                <h2 class="title">
                  <slot name="transcribe"></slot> <span></span>
                </h2>
                <h4 class="caption-about">
                  <slot name="transcribe_description"></slot>
                </h4>
              </div>
              <div
                class="steps-container"
                v-bind:class="{ active: stepsActive.forth }"
                @click="onStepClicked('forth')"
              >
                <h2 class="title">
                  <slot name="translate"></slot> <span></span>
                </h2>
                <h4 class="caption-about">
                  <slot name="translate_description"></slot>
                </h4>
              </div>
              <div
                class="steps-container"
                v-bind:class="{ active: stepsActive.fifth }"
                @click="onStepClicked('fifth')"
              >
                <h2 class="title"><slot name="export"></slot> <span></span></h2>
                <h4 class="caption-about">
                  <slot name="export_description"></slot>
                </h4>
              </div>
              <div v-show="!$isMobile" class="top-margin">
                <a :href="getLoginUrl">
                <button type="button" class="btn btn-custom">
                  <slot name="try_it_now"></slot>
                </button>
              </a>
              </div>
            </div>

            <div
              class="screenshot-container"
            >
            <div class="video-wrapper" @click="onClicked('video1', true)" v-bind:class="{'steps-screenshot':true, 'active1-screenshot':true, 'active': stepsActive.first, 'en-us':isEnglish}">
                <button v-show="!videoState.video1" class="play"></button>
                <div v-if="$isMobile">
                  <video v-if="getLanguage() ==='en-US'" preload="none" poster="../../assets/images/thumbnail/upload_thumbnail_en_US.webp" id="about-video1" ref="video1" playsinline class="unique-video" :src='"@/assets/video/about/upload_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else id="about-video1" preload="none" poster="../../assets/images/thumbnail/upload_thumbnail_zh.webp" ref="video1" playsinline class="unique-video" :src='"@/assets/video/about/upload_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
                </div>
                <div v-else>
                  <video v-if="getLanguage() ==='en-US'" preload="none" autoplay id="about-video1" ref="video1" playsinline class="unique-video" :src='"@/assets/video/about/upload_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else preload="none" id="about-video1" ref="video1" autoplay playsinline class="unique-video" :src='"@/assets/video/about/upload_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
                </div>
            </div>
            <div class="video-wrapper" @click="onClicked('video2', true)" v-bind:class="{'steps-screenshot':true, 'active2-screenshot':true, 'active': stepsActive.second, 'en-us':isEnglish}">
                <button v-show="!videoState.video2" class="play"></button>
                  <video v-if="getLanguage() ==='en-US'" preload="none" poster="../../assets/images/thumbnail/edit_thumbnail_en_US.webp" id="about-video2" ref="video2" playsinline class="unique-video" :src='"@/assets/video/TimestamppedWord_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else preload="none" poster="../../assets/images/thumbnail/edit_thumbnail_zh.webp" id="about-video2" ref="video2" playsinline class="unique-video" :src='"@/assets/video/TimestamppedWord_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
            <div class="video-wrapper" @click="onClicked('video3', true)" v-bind:class="{'steps-screenshot':true, 'active3-screenshot':true, 'active': stepsActive.third, 'en-us':isEnglish}">
                <button v-show="!videoState.video3" class="play"></button>
                  <video v-if="getLanguage() ==='en-US'" preload="none" poster="../../assets/images/thumbnail/aiassist_thumbnail_en_US.webp" id="about-video3" ref="video3" playsinline class="unique-video" :src='"@/assets/video/about/aiassist_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else preload="none" poster="../../assets/images/thumbnail/aiassist_thumbnail_zh.webp" id="about-video3" ref="video3" playsinline class="unique-video" :src='"@/assets/video/about/aiassist_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
            <div class="video-wrapper" @click="onClicked('video4', true)" v-bind:class="{'steps-screenshot':true, 'active4-screenshot':true, 'active': stepsActive.forth, 'en-us':isEnglish}">
                <button v-show="!videoState.video4" class="play"></button>
                  <video v-if="getLanguage() ==='en-US'" preload="none" poster="../../assets/images/thumbnail/translate_thumbnail_en_US.webp" id="about-video4" ref="video4" playsinline class="unique-video" :src='"@/assets/video/about/translate_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else preload="none" poster="../../assets/images/thumbnail/translate_thumbnail_zh.webp" id="about-video4" ref="video4" playsinline class="unique-video" :src='"@/assets/video/about/translate_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
            <div class="video-wrapper" @click="onClicked('video5', true)" v-bind:class="{'steps-screenshot':true, 'active5-screenshot':true, 'active': stepsActive.fifth, 'en-us':isEnglish}">
                <button v-show="!videoState.video5" class="play"></button>
                  <video v-if="getLanguage() ==='en-US'" preload="none" poster="../../assets/images/thumbnail/export_thumbnail_en_US.webp" id="about-video5" ref="video5" playsinline class="unique-video" :src='"@/assets/video/about/export_en_US.mp4"' frameborder="0" height="300"  width="575" muted></video>
                  <video v-else preload="none" poster="../../assets/images/thumbnail/export_thumbnail_zh.webp" id="about-video5" ref="video5" playsinline class="unique-video" :src='"@/assets/video/about/export_zh.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- About End -->
</template>
<script>
import textHelper from "@/utils/textManager";
export default {
  name: "AboutSection",
  data: () => ({
    stepVideoSrc:'',
    stepsActive: {
      first: true,
      second: false,
      third: false,
      forth: false,
      fifth: false,
    },
      videoState:{
          video0:true,
          video1:true,
          video2:true,
          video3:true,
          video4:true,
          video5:true  
      }
    // isActive1:true,
    // isActive2:false,
    // isActive3:false,
    // isActive4:false
  }),
  methods: {
    resetAll() {
      const me = this;
      me.stepsActive.first = false;
      me.stepsActive.second = false;
      me.stepsActive.third = false;
      me.stepsActive.forth = false;
      me.stepsActive.fifth = false;
    },
    onStepClicked(par) {
      const me = this;
      me.resetAll();
      me.stepsActive[par] = true;
      if(par === 'first'){
        me.onClicked('video1', true)
      }
      else if(par === 'second'){
        me.onClicked('video2', true)
      }
      else if(par === 'third'){
        me.onClicked('video3', true)
      }
      else if(par === 'forth'){
        me.onClicked('video4', true)
      }
      else if(par === 'fifth'){
        me.onClicked('video5', true)
      }
    },
    onLogin() {
      window.location.href = textHelper.getAppLoginUrl();
    },
    getLanguage(){
      return  window.localStorage.getItem("PrefferedLanguage") || "en-US";
    },
    onClicked(videoType, isPlay){
        const me = this;

        if(me.getLanguage() === 'en-US'){
          switch(videoType){
            case 'video1':
              me.stepVideoSrc = '@/assets/video/about/aiassist_zh.mp4';
              break;
              default:
              me.stepVideoSrc = '@/assets/video/about/aiassist_zh.mp4';
              break;
          }
        }

        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
        // if(!me.playing){
        //   me.playing = true;
        //   me.$refs[videoType].play();
        //   me.videoState[videoType] = isPlay;
        // }
        // else{
        //   me.playing = false;
        //   me.$refs[videoType].pause();
        //   me.videoState[videoType] = isPlay;
        // }

    }
    // getVideo(src){
    //   const postfix = isEnglish?'en_US':'zh';
      
    //   return src+postfix+'.mp4';
    // }
  },
  computed: {
    isEnglish() {
      const language = this.getLanguage();
      return language === "en-US";
    },
    getLoginUrl(){
      return textHelper.getAppLoginUrl();
    },
  },
  mounted(){
    const me = this;
    const video1 = document.getElementById("about-video1");   
    const video2 = document.getElementById("about-video2");   
    const video3 = document.getElementById("about-video3");  
    const video4 = document.getElementById("about-video4");   

    video1.onended = function() {
        me.videoState.video1 = false;
    }

    if(me.$isMobile){
      // video1.onloadedmetadata = function() {
      //     this.currentTime = this.duration;
      //     me.videoState.video1 = false;
      // } 
    }

    video2.onended = function() {
        me.videoState.video2 = false;
    } 
    // video2.onloadedmetadata = function() {
    //     this.currentTime = this.duration;
    //     me.videoState.video2 = false;
    // } 
    video3.onended = function() {
        me.videoState.video3 = false;
    } 
    // video3.onloadedmetadata = function() {
    //     this.currentTime = this.duration;
    //     me.videoState.video3 = false;
    // } 

    video4.onended = function() {
        me.videoState.video4 = false;
    }
    // video4.onloadedmetadata = function() {
    //     this.currentTime = this.duration;
    //     me.videoState.video4 = false;
    // } 
  }
};
</script>

<style>
section.about {
  background-image: url("../../assets/images/about.webp") !important;
  position:relative;
  padding-bottom:150px;
  margin-top:0px!important;
}
.about-contain {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  height: 100%;
  max-height: 650px;
  display: flex;
}
.about-contain > div {
  width: 100%;
  text-align: center;
  position:relative;
}
/* .about-contain .btn {
  background: #3ccebd;
  font-size: 16px;
}

.about-contain .btn:hover {
  background: #00e0c6;
} */
#about h2.title {
  margin-bottom: 10px !important;
  margin-top: 30px;

  line-height: 28px;
  font-size: 30px !important;
  font-weight: normal;
  margin-bottom: 32px;
  color: #444444;
  text-transform: uppercase;
  letter-spacing: 4px !important;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif !important;
  
    -webkit-transition: all 100ms ease-in-out;
  -moz-transition: all 100ms ease-in-out;
  -o-transition: all 100ms ease-in-out;
  transition: all 300ms ease-in-out;
}
.taption .about .top-margin {
  margin-top: 30px;
  text-align: center;
}
.taption .about .mobile {
    margin-top: 30px;
    text-align: center;
    position: absolute;
    /* top: 2000px;
    left: calc(50% - 70px); */
    top: 1580px;
    left: calc(50% - 70px);
}
.taption .about .top-margin .btn {
  margin-right: 0px auto;
}

.taption .about-right {
  background: #2bfeb7;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #18e786),
    color-stop(99%, #2bfeb7)
  );
  background: linear-gradient(to bottom, rgb(24, 231, 145) 0, #2bfeb7 99%);
}

.taption .about-circle2 {
  z-index: 1;
}

.about .column {
  margin: 0 auto;
}

.steps-screenshot {
  transform: scale(0, 1);
  opacity: 0;
}
.steps-screenshot.active {
  transform: scale(1, 1);
  opacity:1;
}
.steps-container {
  cursor: pointer;
  height: 105px;
  -webkit-transition: all 100ms ease-in-out;
  -moz-transition: all 100ms ease-in-out;
  -o-transition: all 100ms ease-in-out;
  transition: all 300ms ease-in-out;
  background: transparent;
  z-index: 2;
  text-align: center;
  padding: 0px 5px;
}

.steps-container.active h2,
.steps-container.active p {
  color: #1fa363;
}
.steps-container:hover h2.title{
  /* background: #e2f8f2; */
  color: #3ccebd!important;
}
.steps-container.static {
  z-index: -1;
  margin-top: 20px;
  /* background: white; */
  background: #e2f8f2;
  border: 1px solid #3ccebd;
  /* border:1px solid #3ccebd; */

  /* box-shadow: 0 1px 3px #3ccebd; */
  height: 125px;
  width: 100%;
  opacity: 0.4;
  border-radius: 5px;
  position: absolute;
}
.steps-container .title{
  color:#797676!important;
}

.steps-container .caption-about{
  /* color:rgb(126, 123, 123)!important; */
  color:#797676!important;
  font-weight: normal;
  font-size:16px;
}

.steps-container.active .title{
  color:#3ccebd!important;
}
.steps-container.active .caption-about{

  color:#474343!important;
  font-weight: normal;
}

.steps-container.static.active1 {
  transform: translate(0px, 5px);
}
.steps-container.static.active2 {
  transform: translate(0px, 140px);
}
.steps-container.static.active3 {
  transform: translate(0px, 275px);
}
.steps-container.static.active4 {
  transform: translate(0px, 410px);
}
.steps-container.static.active5 {
  transform: translate(0px, 545px);
}

/* .active1-screenshot {
  transform: translate(-565px, 0px) scale(1, 0.1);

}
.active1-screenshot.active {
  transform: translate(0px, 0px);

}
.active2-screenshot {
  transform: translate(-565px, 135px) scale(1, 0.1);
}
.active2-screenshot.active {
  transform: translate(0px, 0px);
}
.active3-screenshot {
  transform: translate(-565px, 265px) scale(1, 0.1);
}
.active3-screenshot.active {
  transform: translate(0px, 0px);
}
.active4-screenshot {
  transform: translate(-565px, 395px) scale(1, 0.1);
}
.active4-screenshot.active {
  transform: translate(0px, 0px);
}
.active5-screenshot {
  transform: translate(-565px, 525px) scale(1, 0.1);
}
.active5-screenshot.active {
  transform: translate(0px, 0px);
} */

.steps-screenshot {
  position: absolute;
  width: 95%;
  -webkit-transition: all 100ms ease-in-out;
  -moz-transition: all 100ms ease-in-out;
  -o-transition: all 100ms ease-in-out;
  transition: all 300ms ease-in-out;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0;
  object-fit: contain;
  vertical-align: middle;
  right: 0;
}

.screenshot-container {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: right;
}

.active {
  opacity: 1;
}

.about .video-wrapper{
  position: absolute;
    width: 570px;
    height:320px;
    /* border: 1px solid lightgray; */
    border-radius: 5px;
    left: 30px;
    box-shadow: 0 1px 4px rgb(1 1 1 / 15%);

  top:130px;
}

.about .video-wrapper video{
  position: absolute;
  top:0;
}

/* .about .video-wrapper.active1-screenshot{
  top:25px;
}
.about .video-wrapper.active2-screenshot{
  top:155px;
}

.about .video-wrapper.active3-screenshot{
  top:64px;
}

.about .video-wrapper.active4-screenshot{
  top:194px;
} */
@media (max-width: 992px) {
  .about-contain > div.screenshot-container{
    position:absolute;
  }
  
  .about .video-wrapper video{
    position:absolute;
    top:0px;
  }
  .about .video-wrapper {
    background: white;
    left: calc(50% - 150px);
    width:300px;
    height:168px;
}

  .about h1 {
    line-height: 60px;
  }
  section.about {
    margin-top: 0px !important;
    padding-bottom: 0px;
  }

  .about-contain {
    max-height: inherit;
  }

  .steps-screenshot {
    opacity: 1;
    width: 200px;
    transform: translate(0px, 0px);
  }
  .steps-container {
    height: 370px;
  }
  .steps-container.static {
    z-index: 1;
    margin-top: 0px;
    background: #e2f8f2;
    height: 35px;
    width: 30%;
    opacity: 0.5;
    position: absolute;
    display: none;
  }

  .steps-container .caption-about{
  /* color:rgb(126, 123, 123)!important; */

  font-weight: normal;
  color:#474343!important;
}

  .steps-container h2 {
    text-align: center;
    font-size: 30px;
  }
  .steps-container p {
    text-align: center;
    font-size: 16px;
  }

  .steps-container.static.active1 {
    transform: translate(0px, 0px);
  }
  .steps-container.static.active2 {
    transform: translate(0px, 135px);
  }
  .steps-container.static.active3 {
    transform: translate(0px, 255px);
  }
  .steps-container.static.active4 {
    transform: translate(0px, 385px);
  }
  .steps-container.static.active5 {
    transform: translate(0px, 515px);
  }

  .about-contain {
    display: block;
    padding: 30px 10px;
  }
  .about-contain > div {
    width: 100% !important;
    left: 0;
  }

  .screenshot-container {
    position: absolute;
    top: 0;
  }
  .video-wrapper.active1-screenshot {
    top: 285px;
  }

  .video-wrapper.active2-screenshot {
    top: 670px;
  }

  .video-wrapper.active3-screenshot {
    top: 1075px;
  }
  .video-wrapper.active4-screenshot {
    top: 1480px;
  }
  .video-wrapper.active5-screenshot {
    top: 1830px;
  }
}
@media (max-width: 400px) {

  .about .video-wrapper video{
    position:absolute;
    top:0px;
  }
  .about .video-wrapper{
    background: white;
    left: calc(50% - 150px);
    width:300px;
    height:168px;
  }
  .video-wrapper.active1-screenshot {
    top: 285px;
  }

  .video-wrapper.active2-screenshot {
    top: 670px;
  }

  .video-wrapper.active3-screenshot {
    top: 1075px;
  }
  .video-wrapper.active4-screenshot {
    top: 1480px;
  }
  .video-wrapper.active5-screenshot {
    top: 1830px;
  }

  /* .active1-screenshot.en-us{
      top: 335px;
      left: calc(50% - 100px);
  }

  .active2-screenshot.en-us{
      top: 730px;
      left: calc(50% - 100px);
  }

  .active3-screenshot.en-us{
      top: 1085px;
      left: calc(50% - 100px);
  }
  .active4-screenshot.en-us{
      top: 1490px;
      left: calc(50% - 100px);
  }
  .active5-screenshot.en-us{
      top: 1880px;
      left: calc(50% - 100px);
  } */
}
</style>
